export default "__VITE_ASSET__Bwrl$2cB__"